import React from 'react'
import { connect } from 'react-redux'
import Wrapper from './WidgetCardWrapper'
import { translate } from 'react-i18next'
import { DATASOURCE } from 'Constants'
import BaseWidget from './BaseWidget'
import { getFormattedTime } from 'helpers/dataFormatter'
import { deepHasOwnProperty } from 'helpers/json_helper'
import { Statistic } from 'semantic-ui-react'

class TeamsMax extends BaseWidget {
  constructor(props) {
    super(props,DATASOURCE.SUMMARY);
  }

  static defaultGridItemProps(){
    return {
      w: 2,
      h: 4,
      maxW: 6,
      maxH: 16
    };
  }

  render() {
    const { t } = this.props;
    let total = deepHasOwnProperty(this.props.summary,"raw","teams","max_ms") ? this.props.summary.raw.teams.max_ms : 0;
    if (isNaN(total)) {
      total = 0;
    }

    return (
      <Wrapper {...this.props}
        isLoading={this.props.summary.loading}
      >
        <div style={{textAlign: "center"}}>
          <Statistic
            label={t("Widgets.Charts.TeamsMax.Label") + '('+getFormattedTime(total)[1]+')'}
            value={getFormattedTime(total)[0]}
            size="small"
          />
        </div>
      </Wrapper>
    );
  }
}

// Helper functions
const mapToProps = state => {
  return {
    summary: state.summary,
    history: state.router
  }
};
        
export default translate()(
  connect(
    mapToProps,
    null
  )(TeamsMax)
);

